import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";
import ProgramTable from "../container/Program/ProgramTable";

const Program = () => {
  const showFlag = false;

  return (
    <React.Fragment>
      <SEO title="Program | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Program"
        content="The Conference"
        contentTwo="Program"
        linkage="/"
      />

      <EmptyTwo>
        {showFlag ? (
          <>
            <div className="entry-content title-center">
              <h2>ICSI&apos;2026 Program Schedule</h2>
            </div>
            <div className="entry-content title-center">
              <ProgramTable />
            </div>

            <div className="space-60"></div>

            <div className="entry-content2">
              <h4>Detailed Scheduled Presentations Timetables</h4>
              <Link
                className="btn btn-primary btn-hover-secondary mt-s"
                to={process.env.PUBLIC_URL + "/sessions"}
              >
                Sessions
              </Link>
            </div>
          </>
        ) : (
          <div className="entry-content title-center">
            <h2>
              Due to the change in the conference host city, we are working
              diligently to rearrange the program. Please stay tuned!
            </h2>
          </div>
        )}
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Program;
